import { eventActionType } from '../../constants';

const initialState = {
  events: [],
  loading: false,
  error: null,
};

const eventReducer = (state = initialState, action) => {
  switch (action.type) {
    case eventActionType.FETCH_EVENTS_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    case eventActionType.FETCH_EVENTS_ALL:
      return {
        ...state,
        events: action.payload,
        error: null,
        loading: false

      };

    case eventActionType.FETCH_EVENTS_ERROR:
      return {
        ...state,
        error: action.payload,
        events: [],
        loading: false
      };

    case eventActionType.FETCH_EVENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };

    // TODO: Add cases for other action types like FETCH_EVENTS_LOADING, FETCH_EVENTS_ERROR, ACTION_EVENT_SUCCESS, ACTION_EVENT_ERROR

    default:
      return state;
  }
};

export default eventReducer; 